import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../../i18n/it";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import moment from "moment";
import { SkillsService } from "../../../../../auth/service/skills.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import { CandidateService } from "../../candidate.service";
import { ICandidate, INoticeTimesObject, INoticeTimesString } from "../../models/candidates";
import { ICity } from "app/auth/models/cities";
import { CitiesService } from "app/auth/service/cities.service";
import { RatingsService } from "../../ratings.service";
import { IRating } from "../../models/ratings";
import { CertificationService } from "../../../../../auth/service/certification.service";

@Component({
  selector: "app-candidate-list",
  templateUrl: "./candidate-list.component.html",
  styleUrls: ["./candidate-list.component.scss"]
})
export class CandidateListComponent implements OnInit {
  public notice_times: INoticeTimesString | INoticeTimesObject[];
  public candidateList: ICandidate[] = [];
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public filter_figure: { id: number; name: string } = { id: null, name: null };
  public filter_skill: number[] = [0];
  public filter_recruiter: { hash: string; name: string } = { hash: null, name: null };
  public filter_rating: { id: number; name: string } = { id: null, name: null };
  public filter_city: { id: number; name: string } = { id: null, name: null };
  public filter_string: string = "";
  public filter_certification: { id: number; name: string } = { id: null, name: null };
  public candidatesFiltered: ICandidate[] = [];
  public candidateRatingsList: IRating[] = [];
  public queryParams: Params = {};
  public pageNumber: number = 0;
  public citiesList: ICity[] = [];

  constructor(
    public _userFigureService: UserFigureService,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    public _skillService: SkillsService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public _candidateService: CandidateService,
    public _userService: UserService,
    public _cityService: CitiesService,
    private _ratingService: RatingsService,
    public _certificationService: CertificationService
  ) {
    this._utilService.disableAutoHideLoading();
    this._utilService.showLoading()
    this.contentHeader = {
      headerTitle: "",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: italian.data.MENU.RECRUITMENT,
            isLink: false
          },
          {
            name: "",
            isLink: false
          }
        ]
      }
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_candidate_list")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.candidateList = await this._candidateService.getCandidatesList().then((r: ICandidate[]) => {
      if (r) {
        r = r.map((item: ICandidate) => {
          item.skill_names = item.skills.map((skill) => skill.skill_name);
          item.date = item.update_date || item.create_date;
          return item;
        });
        return r.sort((a: ICandidate, b: ICandidate) => {
          const dateA = moment(a.date);
          const dateB = moment(b.date);
          return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
        });
      }
      return [];
    });

    if (this._certificationService.list.length < 1) {
      await this._certificationService.getList();
    }

    if (this._userService.recruiter_list.length < 1) {
      await this._userService.getRecruiterList();
    }

    this.citiesList = await this._cityService.getList()

    this.candidateRatingsList = await this._ratingService.getList();

    await this._skillService.getList();
    this.notice_times = await this._utilService.notice_values("object");

    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey: string = params.search;
      const skill: string = params.skill;
      const figure: number = Number(params.figure);
      const recruiter: string = params.recruiter;
      const rating: number = Number(params.rating);
      const city: number = Number(params.city);
      const certification: number = Number(params.certification);
      const page: string = params.page;
      if (!!searchKey) {
        this.filter_string = searchKey;
      }
      if (!!skill && skill != "0") {
        this.filter_skill = JSON.parse(skill);
      }
      if (!!figure && figure > 0) {
        const selectedFigure = this._userFigureService.list.find((item) => item.id == figure);
        this.filter_figure = {id: selectedFigure.id, name: selectedFigure.name}
      }
      if (!!recruiter && recruiter != "all") {
        const selectedRecruiter = this._userService.recruiter_list.find((item) => item.hash === recruiter)
        this.filter_recruiter = {hash: selectedRecruiter.hash, name: selectedRecruiter.complete_name};
      }
      if (!!rating && rating > 0) {
        const selectedRating = this.candidateRatingsList.find((item) => item.id === rating)
        this.filter_rating = {id: selectedRating.id, name: selectedRating.name};
      }
      if (!!city && city > 0) {
        const selectedCity = this.citiesList.find((item) => item.id === city)
        this.filter_city = {id: selectedCity.id, name: selectedCity.name};
      }
      if (!!certification && certification > 0) {
        const selectedCert = this._certificationService.list.find((item) => item.id === certification)
        this.filter_certification = {id: selectedCert.id, name: selectedCert.name};
      }
      if (!!page) {
        this.pageNumber = Number(page);
      }
      this.getItems();
    });

    const headerTitle: string = await this._utilService.translate("TITLES.USERS_TYPES.candidate");
    this.contentHeader.headerTitle = headerTitle;
    this.contentHeader.breadcrumb.links[2].name = headerTitle;

    this._utilService.hideLoading();
  }

  changeQueryParams() {
    const url = new URL(window.location.href);
    if (!!this.filter_string && this.filter_string.length >= 3) {
      url.searchParams.set("search", String(this.filter_string));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_figure && !!this.filter_figure.id) {
      url.searchParams.set("figure", this.filter_figure.id.toString());
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("figure");
      history.pushState({}, "", url);
    }

    if (!!this.filter_recruiter && !!this.filter_recruiter.hash) {
      url.searchParams.set("recruiter", this.filter_recruiter.hash);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("recruiter");
      history.pushState({}, "", url);
    }

    if (!!this.filter_rating && !!this.filter_rating.id) {
      url.searchParams.set("rating", this.filter_rating.id.toString());
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("rating");
      history.pushState({}, "", url);
    }

    if (!!this.filter_city && !!this.filter_city.id) {
      url.searchParams.set("city", this.filter_city.id.toString());
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("city");
      history.pushState({}, "", url);
    }

    if (!!this.filter_skill && !this.filter_skill.includes(0)) {
      url.searchParams.set("skill", JSON.stringify(this.filter_skill));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("skill");
      history.pushState({}, "", url);
    }

    if (!!this.filter_certification && !!this.filter_certification.id) {
      url.searchParams.set("certification", this.filter_certification.id.toString());
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("certification");
      history.pushState({}, "", url);
    }
  }

  getItems() {
    let items: ICandidate[] = this.candidateList;

    const keyword: string = this.filter_string.trim().toLowerCase();
    if (keyword.length > 1) {
      items = items.filter(
        (item: ICandidate) =>
          JSON.stringify(item.skill_names).toLowerCase().includes(keyword) ||
          (item.firstname + " " + item.lastname).toLowerCase().includes(keyword) ||
          item.firstname?.toLowerCase().includes(keyword) ||
          item.lastname?.toLowerCase().includes(keyword) ||
          item.working_city_name?.toLowerCase().includes(keyword) ||
          item.hash === keyword
      );
    }

    if (!!this.filter_figure && !!this.filter_figure.id) {
      const figureID = Number(this.filter_figure.id);
      items = items.filter((item: ICandidate) => Number(item.figure_id) === figureID);
    }

    if (!!this.filter_recruiter && !!this.filter_recruiter.hash) {
      const hash: string = this.filter_recruiter.hash
      items = items.filter((item: ICandidate) => item.creator.hash === hash);
    }

    if (!!this.filter_rating && this.filter_rating.id) {
      const rating: number = Number(this.filter_rating.id);
      items = items.filter((item: ICandidate) => Number(item.judgment) === rating);
    }

    if (!!this.filter_city && !!this.filter_city.id) {
      const cityID = Number(this.filter_city.id)
      items = items.filter((item: ICandidate) => Number(item.working_city_id) === cityID);
    }

    if (!this.filter_skill.includes(0)) {
      items = items.filter((item: ICandidate) => {
        let foundedSkills: number = 0;
        item.skills_ids.map((id: number) => {
          if (this.filter_skill.includes(id)) {
            foundedSkills++;
          }
        });
        return foundedSkills === this.filter_skill.length;
      });
    }

    if (!this.filter_skill.includes(0)) {
      items = items.sort(function(a, b) {
        return ("" + b.skills[0].level).localeCompare(a.skills[0].level);
      });
    }

    if (this.filter_certification && !!this.filter_certification.id) {
      const certID = Number(this.filter_certification.id);
      items = items.filter((item: ICandidate) => item.certifications.some(certification => certification.id === certID));
    }

    this.candidatesFiltered = items;
  }

  filterSkillsForCandidate(list: { id: number; level: string; primary: number; skill_id: number; skill_name: string }[]) {
    if (list.length === 1) {
      return list;
    }
    if (this.filter_skill.includes(0)) {
      return list.filter((skill) => Boolean(skill.primary));
    }
    let filteredSkills = list.filter((skill) => !this.filter_skill.includes(skill.skill_id));
    return filteredSkills.slice(0, 4);
  }

  changeSkill() {
    if (this.filter_skill.includes(0) && this.filter_skill.length >= 2 && this.filter_skill[this.filter_skill.length - 1] === 0) {
      //Se include zero significa che è stata selezionata l'opzione tutte le skill, anche se l'ultimo elemento è zero
      this.filter_skill = [0];
    } else {
      if (this.filter_skill.length > 1) {
        this.filter_skill = this.filter_skill.filter((skill) => skill !== 0);
      } else if (this.filter_skill.length < 1) {
        this.filter_skill = [0];
      }
      this.getItems();
    }
  }

  setPage(pageInfo: { count: number; limit: number; offset: number; pageSize: number }) {
    this.pageNumber = pageInfo.offset;
    const url = new URL(window.location.href);

    if (!!this.pageNumber && this.pageNumber >= 1) {
      url.searchParams.set("page", String(this.pageNumber));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("page");
      history.pushState({}, "", url);
    }
  }

  async deleteUser(hash: string) {
    if (!this._authenticationService.hasCapability("delete_candidate")) {
      window.history.back();
      return false;
    }
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_TITLE",
        text: "CONFIRM_DELETE_USER_TEXT",
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger"
        }
      })
      .then(async (result) => {
        if (result.value) {
          await this._candidateService
            .deleteCandidate(hash)
            .then(async () => {
              await this._utilService.showPopupItemDeleted("CANDIDATE_DELETE_SUCCESSFULLY").then(() => window.location.reload());
            })
            .catch(() => {
              this._utilService.showSWALError("CANDIDATE_DELETE_ERROR");
            });
        }
      });
  }

  filterCertificationsForCandidate(certifications: any) {
    if(this.filter_certification.id){
      const filtered = certifications.filter((certification) => certification.id !== this.filter_certification.id)
      return (filtered.length ? filtered : certifications).slice(0, 2)
    }
    return certifications.slice(0, 2)
  }
}
